import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type WorkspaceCollectionsFragment = (
  { __typename: 'Organization' }
  & Pick<Types.Organization, 'id'>
  & { tags: Array<(
    { __typename: 'Tag' }
    & Pick<Types.Tag, 'id' | 'name'>
  )> }
);

export const WorkspaceCollectionsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkspaceCollections' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Organization' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseWorkspaceCollectionsFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      WorkspaceCollectionsFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseWorkspaceCollectionsFragmentResult
  extends Omit<Apollo.UseFragmentResult<WorkspaceCollectionsFragment>, 'data'> {
  data?: WorkspaceCollectionsFragment;
}

export const useWorkspaceCollectionsFragment = ({
  from,
  returnPartialData,
  ...options
}: UseWorkspaceCollectionsFragmentOptions): UseWorkspaceCollectionsFragmentResult => {
  const result = Apollo.useFragment<WorkspaceCollectionsFragment>({
    ...options,
    fragment: WorkspaceCollectionsFragmentDoc,
    fragmentName: 'WorkspaceCollections',
    from: {
      __typename: 'Organization',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as WorkspaceCollectionsFragment };
};
